import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  link?: { label: string; to: string };
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  link,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        align === "center" ? "md:flex-col md:items-center md:text-center" : ""
      }`}
    >
      <div className={align === "center" ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-600 uppercase">
            <span className="h-px w-6 bg-primary-400" aria-hidden="true" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        ) : null}
      </div>
      {link ? (
        <Link
          to={link.to}
          className="group inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 md:self-auto"
        >
          {link.label}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
        </Link>
      ) : null}
    </div>
  );
}